// A terminal that cannot reach the service is waiting on something nobody in the room can see,
// and it waited four hours in silence once.
const Unreachable = () => (
  <p className="text-sm text-center px-6">
    Cannot reach the server. Still trying &ndash; this will continue on its own
    once the connection is back.
  </p>
);

export default Unreachable;
